{
  "title_providers": "NCPeH - Providers",
  "title_beneficiaries": "NCPeH - Beneficiaries",
  "common": {
    "every": "Every",
    "hour": "hour",
    "hour_multi": "hours",
    "day": "day",
    "day_multi": "days",
    "week": "week",
    "week_multi": "weeks",
    "month": "month",
    "month_multi": "months",
    "year": "year",
    "year_multi": "years",
    "profile": {
      "user_info": "User Information",
      "name": "Name",
      "surname": "Surname",
      "medical_registry_id": "RID",
      "professional_title": "Professional Title",
      "phone": "Phone",
      "email": "E-Mail",
      "address": "Address",
      "specialty_1": "Specialty 1",
      "specialty_2": "Specialty 2",
      "specialty_3": "Specialty 3"
    }
  },
  "login": {
    "login": "Login",
    "exit": "Leave",
    "text_providers": "Through their entrance to the platform, healthcare professionals have the ability to provide healthcare services that concern Patient Summary and Electronic Prescription/Dispensation.",
    "text_beneficiaries": "By logging into the platform, citizens can access their Patient Summary and all issued Electronic Prescriptions, without the ability to make any modifications.",
    "welcome": "Welcome to Cross Border Electronic Healthcare Services"
  },
  "home": {
    "national": "National Citizen",
    "european": "European Citizen",
    "profile": "My Profile",
    "national_text": "Creation or update of a Cypriot citizen's Patient Summary and issuance of a Cross-Border ePrescription.",
    "european_text": "Retrieval of a Patient Summary or dispensation of a Cross-Border ePrescription for a European citizen arriving from another European Union country.",
    "profile_text": "My Profile commentary text",
    "enter": "Enter"
  },
  "select": {
    "labels": {
      "documentType": "Type of Identification Document",
      "information_allergies": "Information about allergies",
      "information_procedures": "Information about surgical procedures",
      "information_problems": "Information about problems/diagnoses",
      "information_devices": "Information about devices/implants",
      "information_medication": "Information about medication"
    },
    "arc": "Alien Registration Card (ARC)",
    "cypriot": "Cypriot Identification Card",
    "10itemsPerPage": "10 items per page",
    "25itemsPerPage": "25 items per page",
    "50itemsPerPage": "50 items per page",
    "100itemsPerPage": "100 items per page",
    "has_allergies": "Has allergies",
    "no_info_allergies": "No information about allergies",
    "no_known_allergies": "No known allergies",
    "has_procedures": "Has surgical procedures",
    "no_info_procedures": "No information about surgical procedures",
    "no_known_procedures": "No known surgical procedures",
    "has_problems": "Has problems/diagnoses",
    "no_info_problems": "No information about problems/diagnoses",
    "no_known_problems": "No known problems/diagnoses",
    "has_devices": "Has devices/implants",
    "no_info_devices": "No information about devices/implants",
    "no_known_devices": "No known devices/implants",
    "has_medication": "Has medication",
    "no_info_medication": "No information about medication",
    "no_known_medication": "No known medication"
  },
  "nav": {
    "patient_data": "Patient Dats",
    "clinical_data": "Patient Clinical Data",
    "summary_data": "Patient Summary Data",
    "allergies": "Allergies",
    "vaccinations": "Vaccinations",
    "history_past_illness": "History of past illnesses"
  },
  "input": {
    "labels": {
      "page": "Page",
      "idNumber": "Identification Document Number",
      "address": "Address",
      "number": "Number",
      "post_code": "Post Code",
      "city": "City",
      "country": "Country",
      "email": "Email Address",
      "telephone": "Mobile Phone Number",
      "otp": "One-Time Password",
      "given_name": "Given Name",
      "family_name": "Family Name/Surname",
      "telephone_number": "Telephone Number",
      "insurance_name": "Insurance Name",
      "insurance_number": "Insurance Number",
      "systolic_bp": "Systolic Blood Pressure",
      "diastolic_bp": "Diastolic Blood Pressure",
      "quantity": "Quantity",
      "frequency_of_use": "Frequency of Use",
      "treatment_duration": "Duration of Treatment",
      "numberOfPackages": "Number of Packages",
      "select_file": "Select File (PDF)",
      "select_image": "Select Image",
      "author_full_name": "Author Full Name",
      "old_email": "Current Email Address",
      "new_email": "New Email Address",
      "old_phone": "Current Mobile Phone Number",
      "new_phone": "New Mobile Phone Number"
    },
    "placeholders": {
      "default": "Type here...",
      "brand_name": "Search by brand name...",
      "active_substance": "Search by active substance...",
      "atc_code": "Search by ATC code...",
      "author_full_name": "Author Full Name"
    }
  },
  "textarea": {
    "labels": {
      "resolution_circumstances": "Resolution Circumstances",
      "treatment_recommendations": "Treatment Recommendation",
      "autonomy_invalidity": "Description",
      "instructions_patient": "Instructions to Patient",
      "instructions_pharmacist": "Instructions to Pharmacist",
      "reason_disabled": "Reason for Disabling Entry"
    },
    "placeholders": {
      "default": "Type here..."
    }
  },
  "dropdown": {
    "labels": {
      "allergy_description": "Allergy Description",
      "drug_allergy_description": "Drug Allergy/Intolerance Description",
      "agent_description": "Allergen Description",
      "allergen_description": "Allergen Description",
      "reaction_description": "Reaction Description",
      "severity_description": "Severity Description",
      "country_description": "Country",
      "vaccination_description": "Vaccine Search",
      "illness_description": "Problems/Diagnosis Description",
      "procedure_description": "Surgical Procedure Description",
      "problem_description": "Problem/Diagnosis Description",
      "device_description": "Device/Implant Description",
      "social_history_description": "Social History Description",
      "blood_type": "Blood Type",
      "pregnancy_description": "Pregnancy Description",
      "medicines_search": "Search for Medicinal Product",
      "package_description": "Package Description",
      "units_intake_description": "Units per Intake",
      "time_unit_description": "Time Units",
      "specialty": "Specialty",
      "reason_of_hospitalization": "Reason of Hospitalization",
      "hospital": "Hospital",
      "laboratory": "Laboratory",
      "medical_center": "Medical Center",
      "brand_name": "Brand Name",
      "pharmacy": "Select Pharmacy"
    },
    "placeholders": {
      "default": "Click here...",
      "allergy_description": "Enter Allergy Description",
      "drug_allergy_description": "Enter Drug Allergy/Intolerance Description",
      "agent_description": "Enter Allergen Description",
      "allergen_description": "Enter Allergen Description",
      "reaction_description": "Enter Reaction Description",
      "severity_description": "Enter Severity Description",
      "country_description": "Enter Country",
      "vaccination_description": "Enter Vaccination Description",
      "illness_description": "Enter Problem/Diagnosis Description",
      "procedure_description": "Enter Surgical Procedure Description",
      "problem_description": "Enter Problem/Diagnosis Description",
      "device_description": "Enter Device/Implant Description",
      "social_history_description": "Enter Social History Description",
      "blood_type": "Enter Blood Type",
      "pregnancy_description": "Enter Pregnancy Description",
      "medicines_search": "Enter Medicinal Product",
      "package_description": "Enter Package Description",
      "units_intake_description": "Enter Units per Intake",
      "time_unit_description": "Enter Frequency Time Unit",
      "specialty": "Specialty",
      "reason_of_hospitalization": "Reason of Hospitalization",
      "select_hospital": "Select Hospital",
      "select_laboratory": "Select Laboratory",
      "select_medical_center": "Select Medical Center"
    },
    "noData": "No data to show. Please perform a search."
  },
  "table": {
    "itemsPerPage": "items per page",
    "page": "Page",
    "of": "of",
    "actions": "Actions",
    "headers": {
      "active": "Active",
      "inactive": "Inactive",
      "successful": "Successful",
      "pending": "Pending",
      "activeOne": "Active",
      "revoked": "Revoked",
      "expired": "Expired"
    }
  },
  "tables": {
    "Demographics": {
      "title": "Patient Demographics Information",
      "headers": {
        "nationalId": "Id",
        "phone": "Telephone",
        "email": "Email",
        "address": "Address",
        "country": "Country"
      }
    },
    "Contacts": {
      "title": "Contact Persons",
      "headers": {
        "given_name": "Given Name",
        "family_name_surname": "Family name/Surname",
        "address": "Address",
        "country": "Country",
        "telephone_no": "Telephone number",
        "email": "Email",
        "status": "Status"
      }
    },
    "Insurances": {
      "title": "Patient Insurance Information",
      "headers": {
        "insurance_name": "Insurance Name",
        "insurance_number": "Insurance Number",
        "status": "Status"
      }
    },
    "Allergies": {
      "title": "Allergies",
      "headers": {
        "allergy_onset_date": "Onset Date",
        "allergy_desc": "Allergy/Intolerance description",
        "reaction_desc": "Reaction Description",
        "agent_desc": "Allergen Description",
        "sev_desc": "Severity",
        "status": "Status"
      }
    },
    "Vaccinations": {
      "title": "Vaccinations",
      "headers": {
        "vaccination_date": "Vaccination Date",
        "brand_name": "Brand Name - Active ingredient (ATC)",
        "description": "Vaccinations",
        "status": "Status"
      }
    },
    "PastIllness": {
      "title": "History of Past Illness",
      "headers": {
        "onset_date": "Onset Date",
        "end_date": "End Date",
        "code": "ICD-10",
        "description": "Illness Description",
        "resolution_circumstances": "Resolution Circumstances",
        "status": "Status"
      }
    },
    "SurgicalProcedures": {
      "title": "Surgical Procedures",
      "headers": {
        "procedure_date": "Procedure Date",
        "description": "Description",
        "status": "Status"
      }
    },
    "ProblemsDiagnoses": {
      "title": "Current Problems/Diagnoses",
      "headers": {
        "onset_date": "Onset Date",
        "code": "ICD-10",
        "description": "Problem/Diagnosis Description",
        "status": "Status"
      }
    },
    "DevicesImplants": {
      "title": "Medical Devices and Implants",
      "headers": {
        "implant_date": "Implant Procedure Date",
        "description": "Device/Implant Description",
        "status": "Status"
      }
    },
    "TreatmentRecommendations": {
      "title": "Treatment Recommendation",
      "headers": {
        "description": "Recommendations Description",
        "status": "Status"
      }
    },
    "AutonomyInvalidity": {
      "title": "Autonomy/Invalidity",
      "headers": {
        "description": "Description",
        "status": "Status"
      }
    },
    "Medication": {
      "title": "Medication Summary",
      "headers": {
        "date_of_onset": "Onset Date",
        "med_atc_label": "Brand Name - Active ingredient (ATC)",
        "strength": "Strength",
        "pharmaceutical_dose_form": "Dose Form",
        "intake": "Units per Intake",
        "frequency": "Frequency of Intakes",
        "duration": "Duration of Treatment",
        "status": "Status"
      }
    },
    "SocialHistory": {
      "title": "Social History",
      "headers": {
        "start_date": "Start Year",
        "end_date": "End Year",
        "description": "Social History Description",
        "status": "Status"
      }
    },
    "PhysicalFindings": {
      "title": "Physical Findings",
      "headers": {
        "date": "Blood Pressure Measurement Date",
        "blood_pressure": "Blood Pressure (Systolic/Diastolic [mmHg])",
        "status": "Status"
      }
    },
    "DiagnosticTests": {
      "title": "Diagnostic Tests",
      "headers": {
        "dt": "Diagnostic Test Date",
        "description": "Result of blood group",
        "status": "Κατάσταση"
      }
    },
    "Pregnancies": {
      "title": "Pregnancy History",
      "headers": {
        "expected_date_of_delivery": "Expected date of delivery",
        "description": "Description",
        "status": "Status"
      }
    },
    "Versions": {
      "title": "Patient Summary Versions",
      "headers": {
        "dt": "Creation Date",
        "author": "Author",
        "specialty": "Specialty",
        "nature_description": "Nature",
        "custodian_name": "Custodian"
      }
    },
    "ePrescriptions": {
      "title": "ePrescriptions (Only for Cross Border eHealth Services)",
      "headers": {
        "prescription_id": "Prescription ID",
        "date_of_issue": "Issue Date",
        "end_date": "Expiry Date",
        "description": "(ATC Code) Description",
        "status": "Status"
      },
      "ePrescriptionDetails": {
        "author": "Author",
        "description": "Description",
        "brandName": "Brand Name",
        "strength": "Strength",
        "pharmaceuticalDoseForm": "Pharmaceutical Dose Form",
        "packaging": "Packaging",
        "atcCode": "ATC Code",
        "activeSubstance": "Active Substance",
        "substitutionAllowed": "Is Substitution of Brand Name Allowed",
        "treatment": "Treatment",
        "quantity": "Quantity",
        "frequency": "Frequency of Intake",
        "route": "Route of Administration",
        "advices": "Advices to Dispenser",
        "duration": "Duration of Treatment",
        "onsetDate": "Onset Date",
        "expiryDate": "Expiry Date",
        "instructions": "Instructions to Patient",
        "dispensationInformation": "Dispensation Information",
        "numberOfPackages": "Number of Packages",
        "routeOfAdministration": "Route of Administration",
        "substitution": "Substitution",
        "dispensationDate": "Dispensation Date",
        "countryOfDispensation": "Country of Dispensation",
        "pharmacistName": "Pharmacist Name",
        "pharmacistTelephone": "Pharmacist Telephone",
        "organization": "Organization"
      },
      "addForm": {
        "searchOfMedicinal": "Search Medicinal Product",
        "brandName": "Brand Name",
        "activeSubstance": "Active Substance",
        "atcCode": "ATC Code",
        "search": "Search",
        "description": "Description",
        "productName": "Product Name",
        "strength": "Strength",
        "pharmaceuticalDoseForm": "Pharmaceutical Dose Form",
        "substitutionAllowed": "Substitution of Brand Name Allowed",
        "yes": "Yes",
        "no": "No",
        "required": "Please fill in this field",
        "packaging": "Packaging",
        "packageDescription": "Package Description",
        "numberOfPackages": "Number of Packages",
        "dosage": "Dosage",
        "quantity": "Quantity",
        "unitsPerIntake": "Units per Intake",
        "frequency": "Frequency of Intake",
        "frequencyUnit": "Frequency Unit",
        "routeOfAdministration": "Route of Administration",
        "duration": "Treatment Duration",
        "durationUnit": "Duration Unit",
        "onsetDate": "Onset Date",
        "instructionsToPatient": "Instructions to Patient",
        "advicesToDispenser": "Instructions to Pharmacist"
      }
    },
    "HospitalReports": {
      "title": "Hospital Discharge Reports",
      "headers": {
        "onset_date": "Onset Date",
        "hcp_name": "Doctor Name",
        "hcp_surname": "Doctor Surname",
        "organization_name": "Organization Name",
        "preview": "Preview",
        "status": "Status"
      }
    },
    "LabReports": {
      "title": "Laboratory Results Reports",
      "headers": {
        "onset_date": "Onset Date",
        "hcp_name": "Doctor Name",
        "hcp_surname": "Doctor Surname",
        "organization_name": "Organization Name",
        "preview": "Preview",
        "status": "Status"
      }
    },
    "MedicalImages": {
      "title": "Medical Images",
      "headers": {
        "onset_date": "Onset Date",
        "hcp_name": "Doctor Name",
        "hcp_surname": "Doctor Surname",
        "organization_name": "Organization Name",
        "preview": "Preview",
        "status": "Status"
      }
    },
    "MedicalReports": {
      "title": "Medical Imaging Reports",
      "headers": {
        "onset_date": "Onset Date",
        "hcp_name": "Doctor Name",
        "hcp_surname": "Doctor Surname",
        "organization_name": "Organization Name",
        "preview": "Preview",
        "status": "Status"
      }
    }
  },
  "date": {
    "labels": {
      "dob": "Date of Birth",
      "on_set": "Onset Date",
      "start_date": "Start Date",
      "end_date": "End Date",
      "start_year": "Start Year",
      "end_year": "End Year",
      "vaccination_date": "Vaccination Date",
      "surgery_date": "Surgical Procedure Date",
      "implant_date": "Implant Procedure Date",
      "bp_measurement_date": "Blood Pressure Measurement Date",
      "test_date": "Date",
      "delivery_date": "Delivery Date"
    },
    "placeholders": {
      "default": "Type here..."
    }
  },
  "button": {
    "yes": "Yes",
    "no": "No",
    "ok": "Ok",
    "cancel": "Cancel",
    "save": "Save",
    "reset": "Reset",
    "search": "Search",
    "create_ps": "Create Patient Record",
    "add_drug_allergy": "Add Drug Allergy",
    "add_non_drug_allergy": "Add Non-Drug Allergy",
    "add_eprescription": "Add Prescription",
    "add_orcd": "Add ORCD",
    "back": "Back",
    "close_preview": "Close preview",
    "tooltips": {
      "edit_ps": "Edit patient record",
      "save_ps": "Save patient record version",
      "discard_ps": "Discard patient record version",
      "enable_entry": "Enable this entry",
      "disable_entry": "Disable this entry",
      "delete_entry": "Delete this entry",
      "add_contact": "Add contact person",
      "add_insurance": "Add patient insurance information",
      "add_drug_allergy": "Add drug allergy",
      "add_non_drug_allergy": "Add non-drug allergy",
      "add_vaccination": "Add vaccination",
      "add_illness": "Add past illness",
      "add_procedure": "Add surgical procedure",
      "add_problem": "Add problem/diagnosis",
      "add_device": "Add medical device/implant",
      "add_treatment": "Add treatment recommendation",
      "add_autonomy": "Add autonomy/invalidity",
      "add_medication": "Add medication",
      "add_social_history": "Add social history",
      "add_physical_finding": "Add blood pressure",
      "add_diagnostic_test": "Add diagnostic test",
      "add_pregnancy": "Add pregnancy history",
      "add_orcd": "Add Original Clinical Documents",
      "save_orcd": "Save Original Clinical Documents",
      "add_lab_report": "Add laboratory result reports",
      "add_hospital_report": "Add hospital discharge reports",
      "add_medical_report": "Add medical imaging reports",
      "add_medical_image": "Add medical images",
      "add_eprescription": "Add ePrescription",
      "preview_pdf": "Preview PDF Document",
      "preview_cda": "Preview CDA Document"
    }
  },
  "modal": {
    "titles": {
      "enable_entry": "Enable Entry",
      "disable_entry": "Disable Entry",
      "delete_entry": "Delete Entry",
      "add_contact": "Add Contact Person",
      "add_insurance": "Add patient insurance information",
      "add_drug_allergy": "Add Drug Allergy",
      "add_non_drug_allergy": "Add Non-Drug Allergy",
      "add_vaccination": "Add Vaccination",
      "add_illness": "Add Past Ιllness",
      "add_procedure": "Add Surgical Procedure",
      "add_problem": "Add Problem/Diagnosis",
      "add_device": "Add Medical Device/Implant",
      "add_treatment": "Add Treatment Recommendation",
      "add_autonomy": "Add Autonomy/invalidity",
      "add_medication": "Add Medication",
      "add_social_history": "Add Social History",
      "add_physical_finding": "Add Blood Pressure",
      "add_eprescription": "Add ePrescription",
      "edit_ps": "Edit Patient Summary",
      "create_ps": "Create Patient Summary",
      "add_diagnostic_test": "Add Diagnostic Test",
      "add_pregnancy": "Add Pregnancy History",
      "add_lab_report": "Add Laboratory Report",
      "add_hospital_report": "Add Hospital Report",
      "add_medical_report": "Add Medical Report",
      "add_medical_image": "Add Medical Image",
      "user_profile": "User Profile",
      "preview_document": "Preview Document",
      "edit_phone": "Edit Phone Number",
      "edit_email": "Edit Email Address",
      "edit_address": "Edit Address",
      "confirm_email": "Confirm One-Time Password"
    },
    "messages": {
      "confirm_enable": "Are you sure you want to enable this entry?",
      "confirm_disable": "Are you sure you want to disable this entry?",
      "confirm_delete": "Are you sure you want to delete this entry?",
      "consent_ps": "I understand that I will become a legal author of the patient summary of the patient {{name}} {{surname}}?"
    },
    "validations": {
      "pi_codingIdInvalid": "The field \"Problems/Diagnosis Description\" is required",
      "pi_onSetDateInvalid": "The field \"Onset Date\" is required",
      "pi_endDateInvalid": "The field \"End Date\" is required",
      "pi_resolutionInvalid": "The field \"Resolution Circumstances\" is required",
      "pi_onSetNotAfterEnd": "The date in the field \"Onset Date\" must be before the date in the field \"End Date\"",
      "pi_startNotAfterPatientDoB": "The date in the field \"Onset Date\" must be after the patient's date of birth",
      "pi_endDateNotBeforeToday": "The date in the field \"End Date\" must be before today's date",
      "m_codingIdInvalid": "The field \"Search for Medicinal Product\" is required",
      "m_packageIdInvalid": "The field \"Package Description\" is required",
      "m_noPackagesInvalid": "The field \"Number of Packages\" is required",
      "m_unitsIntakeInvalid": "The field \"Units per Intake\" is required if the field \"Quantity\" has a valid value",
      "m_frequencyUnitsInvalid": "The field \"Time Units\" is required if the field \"Frequency of Use\" has a valid value",
      "m_durationUnitsInvalid": "The field \"Time Units\" is required if the field \"Duration of Treatment\" has a valid value",
      "m_quantityInvalid": "The field \"Quantity\" is required",
      "m_frequencyInvalid": "The field \"Frequency of Use\" is required",
      "m_durationInvalid": "The field \"Duration of Treatment\" is required",
      "m_onSetDateInvalid": "The field \"Onset Date\" is required",
      "m_onSetDateAfterDOB": "The date in the field \"Onset Date\" must be after the patient's date of birth",
      "m_onSetDateBeforeToday": "The date in the field \"Onset Date\" must be before today's date",
      "m_onSetDateAfterToday": "The date in the field \"Onset Date\" must be after today's date",
      "m_substitutionInvalid": "The field \"Substitution of Brand Name Allowed\" is required",
      "cp_givenNameInvalid": "The field \"Given Name\" is required",
      "cp_familyNameSurnameInvalid": "The field \"Family Name/Surname\" is required",
      "cp_telephoneNoInvalid": "The field \"Address\" is required",
      "cp_countryIdInvalid": "The field \"Country\" is required",
      "cp_addressInvalid": "The field \"Telephone Number\" is required",
      "cp_emailInvalid": "The field \"Email Address\" is required",
      "i_nameInvalid": "The field \"Insurance Name\" is required",
      "i_numberInvalid": "The field \"Insurance Number\" is required",
      "da_allergyCodingIdInvalid": "The field \"Allergy Description\" is required",
      "da_agentCodingIdInvalid": "The field \"Agent Description\" is required",
      "nda_allergenCodingIdInvalid": "The field \"Allergen Description\" is required",
      "da_onSetDateInvalid": "The field \"Onset Date\" is required",
      "da_onSetDateAfterDOB": "The date in the field \"Onset Date\" must be after the patient's date of birth",
      "da_onSetDateBeforeToday": "The date in the field \"Onset Date\" must be before today's date",
      "v_vaccinationIdInvalid": "The field \"Vaccine Search\" is required",
      "v_vaccinationDateInvalid": "The field \"Vaccination Date\" is required",
      "v_vaccinationDateAfterDOB": "The date in the field \"Vaccination Date\" must be after the patient's date of birth",
      "v_vaccinationDateBeforeToday": "The date in the field \"Vaccination Date\" must be before today's date",
      "sp_codingIdInvalid": "The field \"Surgical Procedure Description\" is required",
      "sp_procedureDateInvalid": "The field \"Onset Date\" is required",
      "sp_procedureDateAfterDOB": "The date in the field \"Onset Date\" must be after the patient's date of birth",
      "sp_procedureDateBeforeToday": "The date in the field \"Onset Date\" must be before today's date",
      "pd_codingIdInvalid": "The field \"Problem/Diagnosis Description\" is required",
      "pd_problemDateInvalid": "The field \"Onset Date\" is required",
      "pd_problemDateAfterDOB": "he date in the field \"Onset Date\" must be after the patient's date of birth",
      "pd_problemDateBeforeToday": "The date in the field \"Onset Date\" must be before today's date",
      "di_deviceCodingIdInvalid": "The field \"Device/Implant Description\" is required",
      "di_implantDateInvalid": "The field \"Implant Date\" is required",
      "di_implantDateAfterDOB": "he date in the field \"Implant Date\" must be after the patient's date of birth",
      "di_implantDateBeforeToday": "The date in the field \"Implant Date\" must be before today's date",
      "tr_descriptionInvalid": "The field \"Treatment Recommendation\" is required",
      "ai_descriptionInvalid": "The field \"Description\" is required",
      "sh_codingIdInvalid": "The field \"Social History Description\" is required",
      "sh_startDateInvalid": "The field \"Start Date\" is required",
      "sh_endDateInvalid": "The date in the field \"End Date\" is incorrect",
      "sh_onSetNotAfterEnd": "The date in the field \"Start Date\" must be before the date in the field \"End Date\"",
      "sh_startNotAfterPatientDoB": "The date in the field \"Start Date\" must be after the patient's date of birth",
      "sh_endDateNotBeforeToday": "The date in the field \"End Date\" must be before today's date",
      "pf_systolicInvalid": "The field \"Systolic Blood Pressure\" is required",
      "pf_diastolicInvalid": "The field \"Diastolic Blood Pressure\" is required",
      "pf_systolicLessThanDiastolic": "The value in the field \"Systolic Blood Pressure\" must be higher than the value in the field \"Diastolic Blood Pressure\"",
      "pf_measurementDateInvalid": "The field \"Blood Pressure Measurement Date\" is required",
      "pf_measurementDateAfterDOB": "The date in the field \"Blood Pressure Measurement Date\" must be after the patient's date of birth",
      "pf_measurementDateBeforeToday": "The date in the field \"Blood Pressure Measurement Date\" must be before today's date",
      "dt_codingIdInvalid": "The field \"Blood Group\" is required",
      "dt_dateInvalid": "The field \"Date\" is required",
      "dt_dateAfterDOB": "The date in the field \"Date\" must be after the patient's date of birth",
      "dt_dateBeforeToday": "The date in the field \"Date\" must be before today's date",
      "ph_codingIdInvalid": "The field \"Pregnancy Description\" is required",
      "ph_deliveryDateInvalid": "The field \"Delivery Date\" is required",
      "orcd_hospitalInvalid": "The field \"Hospital\" is required",
      "orcd_authorInvalid": "The field \"Author Full Name\" is required",
      "orcd_specialtyInvalid": "The field \"Specialty\" is required",
      "orcd_hospitalizationInvalid": "The field \"Reason of Hospitalization\" is required",
      "orcd_onSetDateInvalid": "The field \"Onset Date\" is required",
      "οrcd_onSetDateAfterDOB": "The date in the field \"Onset Date\" must be after the patient's date of birth",
      "orcd_onSetDateBeforeToday": "The date in the field \"Onset Date\" must be before today's date",
      "orcd_hfileInvalid": "The field \"Select File (PDF)\" is required",
      "orcd_labInvalid": "The field \"Laboratory\" is required",
      "orcd_medicalCenterInvalid": "The field \"Medical Center\" is required",
      "dem_emailInvalid": "The field \"New Email Address\" is required",
      "dem_emailNewSameOldInvalid": "The value in the field \"New Email Address\" must not be the same as the value in the field \"Current Email Address\"",
      "dem_emailPatternInvalid": "The field \"New Email Address\" is not valid",
      "dem_otpInvalid": "The field \"One-Time Password\" is required",
      "dem_phoneInvalid": "The field \"New Mobile Phone Number\" is required",
      "dem_phoneNewSameOldInvalid": "The value in the field \"New Mobile Phone Number\" must not be the same as the value in the field \"Current Mobile Phone Number\"",
      "dem_addressInvalid": "The field \"Address\" is required",
      "dem_addressNumberInvalid": "The field \"Number\" is required",
      "dem_postalCodeInvalid": "The field \"Post Code\" is required",
      "dem_cityInvalid": "The field \"City\" is required"
    }
  },
  "alert": {
    "titles": {
      "error": "Error:",
      "patient_record_version": "Patient Summary Version:"
    },
    "patient_locked": "Patient is locked by another physician.",
    "patient_not_found": "Patient not found.",
    "patient_error": "While trying to search for a patient.",
    "otp_error": "While entering the password.",
    "demographics_error": "While entering the patient demographics.",
    "patient_version_info": "Date: {1} (Latest) | Doctor: {2}",
    "draft": "Draft"
  },
  "cy": {
    "idTypes": {},
    "idFormats": {
      "arc": "05xxxxxxxx",
      "cypriot": "xxxxxxxxxx"
    },
    "validations": {
      "sfrm_patientIdInvalid": "The \"Identification Document Number\" field is required",
      "sfrm_patientIdCICPatternInvalid": "The \"Identification Document Number\" field must be in the format XXXXXXXXXX",
      "sfrm_patientIdARCPatternInvalid": "The \"Identification Document Number\" field must be in the format \"05-0-XXXXXXX\" consisting of 10 digits.",
      "sfrm_dobDateInvalid": "The field \"Date of Birth\" is required",
      "sfrm_dobBeforeToday": "The date in the field \"Date of Birth\" must be before today's date",
      "dfrm_addressInvalid": "The field \"Address\" is required",
      "dfrm_addressNumberInvalid": "The field \"Number\" is required",
      "dfrm_postalCodeInvalid": "The field \"Post Code\" is required",
      "dfrm_cityInvalid": "The field \"City\" is required",
      "dfrm_emailPatternInvalid": "The field \"Email Address\" is not valid",
      "dfrm_telephoneInvalid": "The field \"Mobile Phone Number\" is required",
      "ofrm_otpInvalid": "The field \"One-Time Password\" is required"
    },
    "otp_expires": "The one-time password expires in {1}.",
    "otp_expired": "The one-time password has expired.",
    "resend_otp": "Resend One-Time Password?",
    "minutes": "minutes",
    "minute": "minute",
    "seconds": "seconds",
    "second": "second",
    "and": "and"
  },
  "eu": {
    "select_country": "Select Country",
    "scan_qr": "Scan from EU Wallet",
    "patient_retrieve": "Patient Data Retrieve Form",
    "regional_id": "Regional identification",
    "regional_search": "Search using the patient's regional identifiers.",
    "or": "OR",
    "national_id": "National identification",
    "national_search": "Search using the patient's national identifier.",
    "search": "Search",
    "prescription_id": "Prescription Id",
    "pin_code": "PIN Code",
    "retrieve": "Retrieve",
    "print": "Print",
    "dispense": "Dispense",
    "display": "Display",
    "prescription_error": "No ePrescription documents found.",
    "document_list": "Patient Documents List",
    "ps_error": "No patient summary documents found."
  },
  "patient": {
    "nodata": "No patient summary record was found or created, please contact your physician to create one.",
    "demographics": {
      "id": "Identity No",
      "name": "Name",
      "surname": "Surname",
      "date_of_birth": "Date of Birth",
      "gender": "Gender",
      "telephone": "Telephone",
      "country": "Country"
    },
    "menu": {
      "ps": "Patient Summary",
      "ep": "Electronic Prescriptions",
      "orcd": "Original Clinical Documents",
      "vac": "European Vaccinations Card",
      "ps_text": "Contains essential information to ensure proper, safe, and timely treatment of the patient.",
      "ep_text": "Allows a patient to receive a prescription for medication from a doctor in their country of permanent residence and fulfill the prescription at a pharmacy in another EU country.",
      "orcd_text": "Documents containing information about your health, such as laboratory result reports, hospital discharge reports, and medical imaging reports.",
      "vac_text": "European Vaccinations Card commentary text",
      "enter": "Enter"
    },
    "summary": {
      "patient_data": "Patient Data",
      "demographics": "Patient Demographics Information",
      "contacts": "Contact Persons",
      "insurances": "Patient Insurance Information",
      "clinical_data": "Patient Clinical Data",
      "allergies": "Allergies",
      "vaccinations": "Vaccinations",
      "past_illness": "History of Past Illness",
      "surgical_procedures": "Surgical Procedures",
      "problems_diagnoses": "Current Problems/Diagnoses",
      "devices_implants": "Medical Devices and Implants",
      "treatments": "Treatment Recommendation",
      "autonomy_invalidity": "Autonomy/Invalidity",
      "medication": "Medication Summary",
      "social_history": "Social History",
      "physical_findings": "Physical Findings",
      "diagnostic_tests": "Diagnostic Tests",
      "pregnancies": "Pregnancy History",
      "versioning_data": "Patient Summary Data",
      "versions": "Versions"
    },
    "ps": {
      "medication": {
        "atc_code": "ATC Code",
        "active_substance": "Active Substance(s)",
        "product_name": "Product Name",
        "strength": "Strength",
        "dose_form": "Pharmaceutical Dose Form",
        "description": "Description",
        "dosage": "Dosage",
        "packaging": "Packaging",
        "not_applicable": "Not Applicable",
        "every": "every",
        "hour": "Hour(s)",
        "day": "Day(s)",
        "week": "Week(s)",
        "month": "Month(s)",
        "year": "Year(s)",
        "administration_route": "Route of Administration",
        "substitutionAllowed": "Substitution of Brand Name Allowed",
        "substitution": "Substitution",
        "dispensation_form": "Dispensation Form",
        "dispense": "Dispense",
        "ep_list": "Patient ePrescription List"
      },
      "vaccinations": {
        "vaccinations": "Vaccinations",
        "description": "Description",
        "brand_name": "Brand Name"
      }
    },
    "orcd": {
      "title": "Original Clinical Documents",
      "hospital_reports": "Hospital Reports",
      "lab_reports": "Lab Reports",
      "medical_images": "Medical Images",
      "medical_reports": "Medical Reports"
    }
  },
  "switch": {
    "brandName": "Search by brand name",
    "code": "Search by code",
    "description": "Search by description"
  },
  "radios": {
    "brand_name": "Brand Name",
    "active_substance": "Active Substance",
    "atc_code": "ATC Code",
    "yes": "Yes",
    "no": "No"
  },
  "breadcrumb": {
    "home": "Home",
    "cy": "National Citizen",
    "eu": "European Citizen",
    "patient": "Patient Menu",
    "ps": "Patient Summary",
    "edit": "Edit",
    "create": "Create",
    "ep": "Electronic Prescriptions",
    "orcd": "Original Clinical Documents",
    "at": "Austria",
    "be": "Belgium",
    "bg": "Bulgaria",
    "cz": "Czech Republic",
    "de": "Germany",
    "dk": "Denmark",
    "ee": "Estonia",
    "es": "Spain",
    "fi": "Finland",
    "fr": "France",
    "gr": "Greece",
    "hr": "Croatia",
    "hu": "Hungary",
    "ie": "Ireland",
    "is": "Iceland",
    "it": "Italy",
    "lt": "Lithuania",
    "lu": "Luxembourg",
    "lv": "Latvia",
    "mt": "Malta",
    "nl": "Netherlands",
    "pl": "Poland",
    "pt": "Portugal",
    "ro": "Romania",
    "rs": "Serbia",
    "se": "Sweden",
    "si": "Slovenia",
    "sk": "Slovakia",
    "sw": "Switzerland",
    "uk": "United Kingdom"
  }
}
